import { Company } from "../../models/Company";
import { WrapperFactory } from "../WrapperFactory";

let companiesApi = {
    async get(page, token,params={}){
        let response = await window.axios.get('/api/companies', {
            params:{
                api_token:token,
                user_companies: true,
                ...params
            }
        });
        let wrapper = WrapperFactory.fromResponse(response.data)
        wrapper.transform(e=>new Company(e));
        return wrapper;
    },
    async getCompany(id, token,params={}){
        let response = await window.axios.get('/api/companies/'+id, {
            params:{
                api_token:token,
                ...params
            }
        });
        return new Company(response.data);
    },
    async getSuppliers(token, company_logged,params={}, fields=['id', 'name', 'trade', 'cnpj', 'email'], relationships=['areasOfInterest:id,name']){
        let response = await window.axios.get('/api/companies/'+company_logged+'/suppliers', {
            params:{
                api_token:token,
                ...params
            }
        });
        let wrapper = WrapperFactory.fromResponse(response.data)
        wrapper.transform(e=>new Company(e));
        return wrapper
    },

    async getOffices(token, company_logged,params={}){
        let response = await window.axios.get('/api/companies/'+company_logged+'/offices', {
            params:{
                api_token:token,
                ...params
            }
        });
        let wrapper = WrapperFactory.fromResponse(response.data)
        wrapper.transform(e=>new Company(e));
        return wrapper.data;
    },
    async getGroup(token, company_logged, params={}){
        let response = await window.axios.get('/api/companies/'+company_logged+'/group', {
            params:{
                api_token:token,
                ...params
            }
        });
        let wrapper = WrapperFactory.fromResponse(response.data)
        return wrapper.data;
    },
    async getRtContacts(token, company_logged,params={}, fields=['id', 'name', 'trade', 'cnpj', 'email'], relationships=['areasOfInterest:id,name']){
        let response = await window.axios.get('/api/rt-contact', {
            params:{
                api_token:token,
                company_id:company_logged,
                ...params
            }
        });
        let wrapper = WrapperFactory.fromResponse(response.data)
        return wrapper.data;
    },
    async getGroup(token, company_logged, params={}){
        let response = await window.axios.get('/api/companies/'+company_logged+'/group', {
            params:{
                api_token:token,
                ...params
            }
        });
        let wrapper = WrapperFactory.fromResponse(response.data)
        return wrapper.data;
    },

    async getRtContacts(token, company_logged,params={}, fields=['id', 'name', 'trade', 'cnpj', 'email'], relationships=['areasOfInterest:id,name']){
        let response = await window.axios.get('/api/rt-contact', {
            params:{
                api_token:token,
                company_id:company_logged,
                ...params
            }
        });
        let wrapper = WrapperFactory.fromResponse(response.data)
        return wrapper.data;
    },

    async getExtraFields(token, company_logged,type, params={}){
        let response = await window.axios.get('/api/companies/'+company_logged+'/extraInfo', {
            params:{
                api_token:token,
                type:type,
                ...params
            }
        });
        let wrapper = WrapperFactory.fromResponse(response.data)
        return wrapper.data;
    },
    async getExtraFieldAnswers(token, company_logged, params={}){
        let response = await window.axios.get('/api/companies/'+company_logged+'/extraInfoAnswers', {
            params:{
                api_token:token,
                company_logged:company_logged,
                ...params
            }
        });
        let wrapper = WrapperFactory.fromResponse(response.data)
        return wrapper.data;
    },
    async getEmployees(token, company_logged, office_id, params={}){
        let response = await window.axios.get('/api/companies/'+office_id+'/employees', {
            params:{
                api_token:token,
                company_logged:company_logged,
                ...params
            }
        });
        let wrapper = WrapperFactory.fromResponse(response.data)
        return wrapper.data;
    }



}

export default companiesApi
